import { createSlice } from '@reduxjs/toolkit';
import { first, flatten, map } from 'lodash';

const initialState = {
  username: '',
  email: '',
  userId: null,
  firstName: '',
  lastName: '',
  currentTenantId: null,
  currentTenantRoles: [],
  fulfillingPharmacies: [],
};

/* eslint no-param-reassign: ["error", { "ignorePropertyModificationsFor": ["state"] }] */
const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    resetAuthState(state) {
      Object.assign(state, initialState);
    },
    loadUserData(state, action) {
      const { userData } = action.payload;
      state.username = userData.email;
      Object.assign(state, userData);

      if (!state.currentTenantId) {
        const firstTenantId = first(userData.tenants)?.id;
        const tenantDetails = userData.userRoles?.[firstTenantId] || {};

        const fulfillingPharmacies = flatten(
          map(tenantDetails.allowedFulfillingPharmacies, (item) => Object.values(item))
        );

        state.currentTenantId = firstTenantId || null;
        state.currentTenantRoles = tenantDetails.roles || [];
        state.fulfillingPharmacies = fulfillingPharmacies;
      }
    },
  },
});

export const authActions = authSlice.actions;
export default authSlice.reducer;
